import { z } from 'zod'
import { EmailSchema } from '#app/utils/user-validation.ts'

export function getSubmitBusinessSchema({
	isLoggedIn,
}: {
	isLoggedIn: boolean
}) {
	return z
		.object({
			intent: z.literal('submit-business'),
			name: z
				.string({ error: 'Business name is required' })
				.min(1, { error: 'Business name is required' }),
			addressStreet: z.string().optional(),
			addressCity: z.string().optional(),
			addressRegion: z.string().default('Texas'),
			addressZip: z.string().optional(),
			addressCountryCode: z.string().default('US'),
			website: z
				.union([z.url({ error: 'Website must be a valid URL' }), z.literal('')])
				.optional(),
			note: z
				.string()
				.max(1000, { error: 'Note must be 1000 characters or less' })
				.optional(),
			contactName: z.string().default(''),
			contactEmail: EmailSchema.optional(),
			categoryIds: z.array(z.string()).optional().default([]),
			subcategoryIds: z.array(z.string()).optional().default([]),
			cityIds: z.array(z.string()).optional().default([]),
		})
		.superRefine((data, ctx) => {
			if (!isLoggedIn) {
				if (!data.contactName || data.contactName.trim().length < 3) {
					ctx.addIssue({
						path: ['contactName'],
						code: 'custom',
						message: 'Name is required',
					})
				}
				if (!data.contactEmail) {
					ctx.addIssue({
						path: ['contactEmail'],
						code: 'custom',
						message: 'Email is required',
					})
				}
			}
		})
}

export interface SubmitBusinessForm {
	intent: 'submit-business'
	name: string
	addressStreet?: string
	addressCity?: string
	addressRegion?: string
	addressZip?: string
	addressCountryCode?: string
	website?: string
	note?: string
	contactName?: string
	contactEmail?: string
	categoryIds?: string[]
	subcategoryIds?: string[]
	cityIds?: string[]
}
